module.exports = __webpack_public_path__ + "static/media/tap_10_img.816834c9.png";